//#region src/staleChunk/ChunkLoadError.ts
var e = class extends Error {
	constructor(e, t) {
		super(e), this.name = "ChunkLoadError", this.cause = t;
	}
};
//#endregion
export { e as ChunkLoadError };
